import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
} from "@angular/core";
import { Router } from "@angular/router";

import {
    SignInMutation,
    SignInMutationVariables,
} from "../../../common/generated-types";
import { DataService } from "../../../core/providers/data/data.service";
import { StateService } from "../../../core/providers/state/state.service";

import { SIGN_IN } from "./sign-in.graphql";

@Component({
    selector: "vsf-sign-in",
    templateUrl: "./sign-in.component.html",
    styleUrls: ["./sign-in.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInComponent {
    @Input() navigateToOnSuccess: string | any[] | undefined;
    @Input() displayRegisterLink = true;

    emailAddress: string;
    password: string;
    rememberMe = false;
    errorMessage = "";
    shake = false;
    signInInProgress = false;

    constructor(
        private dataService: DataService,
        private stateService: StateService,
        private router: Router,
        private changeDetector: ChangeDetectorRef
    ) {}

    signIn() {
        if (this.signInInProgress) {
            return;
        }
        this.signInInProgress = true;
        this.changeDetector.markForCheck();
        this.dataService
            .mutate<SignInMutation, SignInMutationVariables>(SIGN_IN, {
                emailAddress: this.emailAddress,
                password: this.password,
                rememberMe: this.rememberMe,
            })
            .subscribe({
                next: ({ login }) => {
                    const target = this.navigateToOnSuccess || ["/"];
                    switch (login.__typename) {
                        case "CurrentUser":
                            this.stateService.setState("signedIn", true);
                            const nav =
                                typeof target === "string"
                                    ? this.router.navigateByUrl(target)
                                    : this.router.navigate(target);
                            nav.then(() => {
                                window.location.reload();
                            });
                            break;
                        case "NotVerifiedError":
                            this.signInInProgress = false;
                            this.showError("Your account is not approved yet");
                            break;
                        case "NativeAuthStrategyError":
                        case "InvalidCredentialsError":
                            this.signInInProgress = false;
                            this.showError(
                                login.message ||
                                    (login as any).authenticationError ||
                                    "Invalid credentials"
                            );
                            break;
                        default:
                            this.signInInProgress = false;
                            this.changeDetector.markForCheck();
                            break;
                    }
                },
                error: () => {
                    this.signInInProgress = false;
                    this.changeDetector.markForCheck();
                },
            });
    }

    showError(message: string) {
        this.errorMessage = message;
        this.shake = false;
        this.changeDetector.markForCheck();
        setTimeout(() => {
            this.shake = true;
            this.changeDetector.markForCheck();
        }, 10);
        setTimeout(() => {
            this.shake = false;
            this.changeDetector.markForCheck();
        }, 600);
    }
}
